export function isUserDeniedSignature(error: any) {
    return error.code === -32603 && error.message === "MetaMask Typed Message Signature: User denied message signature."
}
